export const availableLanguages = [
  'en',
  'es',
  'fr',
  'nl',
  'ru'
];



/** WEBPACK FOOTER **
 ** ./data/LanguageStreams.js
 **/